module.exports = __webpack_public_path__ + "img/document-text-outline.a4bf22c5.svg";